<script>
	import journey from "../../stores/journey.js";
	import windows from "../../stores/windows.js";
	import chronology from "../../stores/chronology.js";
	import cairns, { MINIMUM_CAIRN_BUILD_INTERVAL_MS } from "../../stores/cairn.js";
	import { locality as localityAt } from "../../api/api.js";
	import Plate from "../content/vehicle/Plate.svelte";

	export let window;

	let locality;

	if (window.props.cairn) {
		localityAt(window.props.cairn).then((result) => {
			locality = result.locality;
		});
	} else if (window.props.follow) {
		locality = window.props.follow;
	}

	$: canBuildCairn =
		($cairns.lastBuiltAt > $chronology.duration ||
			$chronology.duration - ($cairns.lastBuiltAt || 0) > MINIMUM_CAIRN_BUILD_INTERVAL_MS) &&
		$windows.some(({ isClosed, kind }) => isClosed !== true && kind === "build-cairn") === false;

	function didClickLocateButton() {
		let location = null;

		if (window.props.cairn) {
			location = window.props.cairn;
		} else if (window.props.center) {
			location = window.props.center;
		} else if ($journey.location) {
			location = $journey.location;
		}

		if (!location) {
			return;
		}

		globalThis.dispatchEvent(
			new CustomEvent("map:viewport", {
				detail: { ...location, window: window.id }
			})
		);
	}

	function didClickBuildCairnButton() {
		windows.focus(windows.open("build-cairn"));
	}
</script>

<button on:click={didClickLocateButton}>
	<span>
		<svg width="15" height="15" viewBox="0 0 15 15" fill="black">
			<path d="M14.2441 0.898895L0.24408 7.70842L6 9L8 15L14.2441 0.898895Z" />
		</svg>
	</span>
</button>

<div class="spacer" />

{#if window.props.cairn}
	{#if locality}
		<div class="locality">{locality}</div>
	{/if}
{:else if window.props.follow}
	<div class="locality">
		<Plate number={window.props.follow} />
	</div>
{:else}
	<button on:click={didClickBuildCairnButton} disabled={!canBuildCairn}> Build Cairn </button>
{/if}

<style>
	button {
		appearance: none;
		cursor: pointer;
		margin: var(--spacing);
		border: none;
		background: none;
		padding: 0;
		touch-action: manipulation;
		color: #000000;
		text-decoration: underline;
		white-space: nowrap;
	}

	button:disabled {
		pointer-events: none;
		color: #999999;
		text-decoration: none;
		text-shadow: 0 1px rgba(255, 255, 255, 0.75);
	}

	span {
		display: block;
		position: relative;
		top: 1px;
		color: black;
	}

	.spacer {
		flex-grow: 1;
	}

	.locality {
		margin: var(--spacing);
	}
</style>
